module.exports = __webpack_public_path__ + "static/sc-03-e556153c21c18fe3cd9ed65af04fdaa4.png";